export default __webpack_public_path__ + "static/media/bestbuyLogo.d0eb87a4.png";